module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Design Saarinen ","short_name":"Design Saarinen ","start_url":"https://designsaarinen.fi","scope":"https://designsaarinen.fi","icon":"src/images/favicon.png","legacy":true,"display":"browser"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
